<template>
  <div id="app">
    <div class="title">会员详情</div>
    <form id="forms" action="" method="post">
      <div class="content">
        <b>*</b>
        <span>姓名</span>
        <input id="" v-model="vip_name" class="inp" name="baobao_name" type="text" value=""/>

        <span>别名</span>
        <input id="" v-model="nick_name" class="inp" name="baobao_name2" type="text" value=""/>

        <b>*</b>
        <span>出生日期</span>
        <el-date-picker
          v-model="birth"
          name="baobao_birthday"
          placeholder="选择日期"
          size="small"
          style="width:160px"
          type="date">
        </el-date-picker>

        <b>*</b>
        <span style="margin-right:20px">性别</span>
        <el-radio v-model="radio" label="男" name="baobao_sex">男</el-radio>
        <el-radio v-model="radio" label="女" name="baobao_sex">女</el-radio>
        <!-- 分割线 -->
        <div style="height:20px"></div>
        <b>*</b>
        <span>来源</span>
        <select v-model="source_name" name="laiyuan" style="margin-right:61px">
          <option v-for="item in options" :value="item.label">
            {{ item.label }}
          </option>
        </select>

        <div v-if="source_name == '其他'" class="remark">
          <b>*</b>
          <span>来源备注</span>
          <input id="" v-model="bz" class="inp" name="bz" type="text" value=""/>
        </div>

        <!--				<b>&nbsp;</b>-->
        <!--				<span>国籍</span>-->
        <!--				<input type="text" v-model="country" class="inp" name="country" id="" value="" />-->

        <b>&nbsp;</b>
        <span>身份证号</span>
        <input id="" v-model="id_number" class="inp" name="id_number" type="text" value=""/>
        <!-- 分割线 -->
        <!--				<div style="height:20px" v-if="source_name == '其他'"></div>-->
        <!--				<b>&nbsp;</b>-->
        <!--				<span>药物</span>-->
        <!--				<input type="text" v-model="drugs" class="inp" name="drugs" id="" value="" />-->
        <!-- 分割线 -->
        <!--/*				<div style="height:20px" v-if="source_name !== '其他'"></div>*/-->

        <!--				<b>&nbsp;</b>-->
        <!--				<span>食品</span>-->
        <!--				<input type="text" v-model="food" class="inp" name="food" id="" value="" />-->

        <!--				<b>&nbsp;</b>-->
        <!--				<span>医院</span>-->
        <!--				<input type="text" v-model="hospital" class="inp" name="hospital" id="" value="" />-->

        <!--				<b>&nbsp;</b>-->
        <!--				<span>医生</span>-->
        <!--				<input type="text" v-model="doctor" class="inp" name="doctor" id="" value="" />-->
      </div>

      <div class="title">家长的联系方式</div>
      <div v-for="(a,indexs) in clone" class="line">
        <b style="margin-left: 20px;">*</b>
        <span>关系</span>
        <select name="guanxi[]">
          <option v-for="(item,index) in relation" :value="item.value">
            {{ item.name }}
          </option>
        </select>

        <b>*</b>
        <span>姓名</span>
        <input id="" ref="names" class="inp" name="name[]" type="text" value=""/>

        <b>*</b>
        <span>联系电话</span>
        <input id="" ref="tels" class="inp" maxlength="11" name="phone[]" type="text" value="" @blur="tel_change"/>
        <div style="display: inline-block;vertical-align: middle;">
          <img v-if="a == 0" src="/static/qmsj/img/+.png" style="margin: 3px 0 0 4px;" @click="lineShow"/>
          <img v-if="a > 0" src="/static/qmsj/img/genjin/-.png" style="margin: 3px 0 0 4px;" @click="lineHide(indexs)"/>
        </div>
      </div>

      <div class="title">家庭住址</div>
      <b v-if="must_site" style="margin-left: 20px;">*</b>

      <!--省市区三级联动-->
      <select v-model="prov_id" name="coun" @change="prov_save">
        <option value="">请选择省份</option>
        <option v-for="(item,index) in provList" :value="item.REGION_ID">
          {{ item.REGION_NAME }}
        </option>
      </select>
      <select v-model="city_id" name="sheng" @change="city_save">
        <option value="">请选择城市</option>
        <option v-for="(item,index) in cityList" :value="item.REGION_ID">
          {{ item.REGION_NAME }}
        </option>
      </select>
      <select v-model="county_id" name="qu">
        <option value="">请选择地区</option>
        <option v-for="(item,index) in countyList" :value="item.REGION_ID">
          {{ item.REGION_NAME }}
        </option>
      </select>

      <b v-if="must_site" style="margin-left: 20px;">*</b>
      <span>详细地址</span>
      <input id="" v-model="address" class="inp" name="site" style="width: 220px;" type="text" value=""/>
      <div style="margin-top: 20px;">
        <span style="float: left;margin-top: 20px;margin-right: 5px;">备注</span>
        <el-input v-model="remark" :rows="2" name="beizhu" placeholder="请输入内容" style="width: 45%;"
                  type="textarea"></el-input>
      </div>

      <input id="" v-model="token" name="token" type="hidden" value=""/>
      <input class="submit-btn" style="padding: 10px 15px;height:40px; " type="button" value="提交" @click="submit"/>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      birth: '',
      value2: '',
      //单选框
      radio: '男',
      isShow: false,
      //省市区三级联动
      prov_id: '',
      city_id: '',
      county_id: '',
      provList: [],
      cityList: [],
      countyList: [],
      relation: [
        {name: '爸爸', value: 1},
        {name: '妈妈', value: 2},
        {name: '爷爷', value: 3},
        {name: '奶奶', value: 4},
        {name: '姥爷', value: 5},
        {name: '姥姥', value: 6},
      ],
      relation_name: '',
      options: "",
      token: '',
//              姓名
      vip_name: '',
      nick_name: '',
      parent_name: '',
      tel: '',
      tel_state: false,
      address: '',
      source_name: '市场',//来源
      remark: '',//备注
      clone: [0],
      add_index: 0,
      bz: '',
      drugs: '',
      country: '中国',
      id_number: '',
      food: '',
      hospital: '',
      doctor: '',
      centre_id: 0,
      must_site: false
    }
  },
  created() {
    let that = this
    that.token = that.$cookies.get('token');
    //获取中心ID
    $.ajax({
      url: process.env.apiUrl + 'saas/index/query_centre_id',
      type: 'post',
      data: {
        token: that.token
      },
      success: function (data) {
        that.centre_id = data.centre_id
        //省
        $.ajax({
          url: process.env.apiUrl + 'saas/Qk/sheng',
          type: 'post',
          data: {
            token: that.token
          },
          success: function (data, status) {
            if (data.status == 1) {
              that.provList = data.data
            } else {
              that.$message.error({message: data.msg})
            }
          },
          fail: function (err, status) {
            console.log(err)
          }
        })
        // 来源下拉
        $.ajax({
          url: process.env.apiUrl + 'saas/index/get_source',
          type: 'post',
          data: {
            token: that.token
          },
          success: function (e) {
            if (e.status == 1) {
              that.options = e.data
            } else {
              that.$message.error({message: e.msg})
            }
          },
        })
      },
      fail: function (err, status) {
        console.log(err)
      }
    })

  },
  methods: {
    //省市区三级联动
    prov_save() {
      let that = this
      $.ajax({
        url: process.env.apiUrl + 'saas/Qk/sel_coun',
        type: 'post',
        data: {
          coun: that.prov_id,
          token: that.token
        },
        success: function (data, status) {
          if (data.status == 1) {
            that.cityList = data.data
          } else {
            that.$message.error({message: data.msg})
          }
        },
        fail: function (err, status) {
          console.log(err)
        }
      })
    },
    city_save() {
      let that = this
      $.ajax({
        url: process.env.apiUrl + 'saas/Qk/sel_coun',
        type: 'post',
        data: {
          coun: that.city_id,
          token: that.token
        },
        success: function (data, status) {
          if (data.status == 1) {
            that.countyList = data.data
          } else {
            that.$message.error({message: data.msg})
          }
        },
        fail: function (err, status) {
          console.log(err)
        }
      })
    },
    //手机号正则验证
    tel_change() {
      let myreg = /^[0-9]{11}$/;
      for (let i in this.$refs.tels) {
        if (!myreg.test(this.$refs.tels[i].value)) {
          this.$message.error({message: '请输入正确手机号'})
          return false;
        } else {
          let that = this
          $.ajax({
            url: process.env.apiUrl + 'saas/Qk/yz',
            type: 'post',
            data: {
              phone: that.$refs.tels[i].value,
              token: that.token
            },
            success: function (data, status) {
              if (data.status == 1) {
                that.$message.error({message: data.msg})
                that.tel_state = false;
              } else {
                that.tel_state = true;
              }
            },
            fail: function (err, status) {
              console.log(err)
            }
          })
        }
      }
    },
//	 	 	提交表单
    submit() {
//          	判断input框是否为空
      if (this.vip_name == '') {
        this.$message.error({message: '姓名不能为空'})
        return false;
      }
      if (this.birth == '') {
        this.$message.error({message: '出生日期不能为空'})
        return false;
      }
      for (let i in this.$refs.names) {
        if (this.$refs.names[i].value == '') {
          this.$message.error({message: '家长姓名不能为空'})
          return false;
        }
      }
      for (let i in this.$refs.tels) {
        if (this.$refs.tels[i].value == '') {
          this.$message.error({message: '手机号不能为空'})
          return false;
        }
      }
      if (!this.tel_state) {
        this.$message.error({message: '手机号已存在'})
        return false;
      }
      if (this.must_site) {
        if (this.prov_id == '') {
          this.$message.error({message: '省份不能为空'})
          return false;
        }

        if (this.city_id == '') {
          this.$message.error({message: '城市不能为空'})
          return false;
        }

        if (this.address == '') {
          this.$message.error({message: '详细地址不能为空'})
          return false;
        }
      }

      //提交表单
      var formData = new FormData($('#forms')[0]);
      let that = this
      $.ajax({
        url: process.env.apiUrl + 'saas/Qk/luruqiank',
        type: "post",
        async: false,
        processData: false, // 不处理发送的数据，因为data值是Formdata对象，不需要对数据做处理
        contentType: false, // 不设置Content-type请求头
        data: formData,
        success: function (data) {
          if (data.status == 1) {
            that.$message.success(data.msg);
            //清空表单内容
            that.vip_name = '';
            that.nick_name = '';
            that.birth = '';
            that.parents_name = '';
            that.tel2 = '';
            that.address = '';
            that.remark = '';
            that.source_name = '市场';
            that.bz = '';
            that.drugs = '';
            that.country = '中国';
            that.id_number = '';
            that.food = '';
            that.hospital = '';
            that.doctor = '';
            for (let i in that.$refs.names) {
              that.$refs.names[i].value = ''
            }
            for (let i in that.$refs.tels) {
              that.$refs.tels[i].value = ''
            }
          } else {
            that.$message.error(data.msg);
          }
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },
    //隐藏显示
    lineShow() {
      if (this.add_index < 5) {
        this.add_index++
        this.clone.push(this.add_index)
      }
    },
    lineHide(i) {
      if (this.add_index > 0) {
        this.add_index--
        this.clone.splice(i, 1)
      }
    }
  }
}
</script>

<style lang="less" scoped="scoped">
#app {
  padding: 36px;
  min-width: 1096px;
}

.title {
  text-indent: 10px;
  font-size: 16px;
  height: 24px;
  line-height: 24px;
  border-left: 4px solid #8CBB77;
  margin-bottom: 10px;
}

form {
  .content {
    width: 1080px;
    padding: 25px 6px;
    background: #f1eff2;
    margin-bottom: 10px;
  }

  .remark {
    display: inline-block;

    label {
      float: left;
      margin-top: 34px;
      font-weight: bold;
      margin-left: 28px;
      margin-right: 3px
    }

    textarea {
      height: 30px;
      width: 100px;
      resize: none;
      padding: 4px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-top: 23px
    }
  }

  .send {
    position: relative;
    width: 116px;
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    text-align: center;
    background-color: white;
    border: 1px solid red;
    border-radius: 5px;
    z-index: 99;

    .arrow {
      position: absolute;
      top: -13px;
      right: 95px;
      width: 0;
      height: 0;
      font-size: 0;
      border: 6px solid;
      border-color: #f1eff2 #f1eff2 red #f1eff2;
    }
  }

  b {
    color: red;
    height: 26px;
    line-height: 26px;
    margin-left: 30px;
  }

  .inp {
    padding-left: 10px;
    width: 160px;
    height: 30px;
    border: 1px solid #dbdbdb;
    background: #fff;
    vertical-align: middle;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 135px;
    background: #fff;
  }

  .el-radio + .el-radio {
    margin-left: 15px;
  }

  select {
    /*width: 110px;*/
    height: 30px;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    background: #fff;
    padding-left: 5px;
  }

  .line {
    margin-bottom: 10px;
  }

  .add {
    width: 26px;
    vertical-align: middle;
    text-align: center;
    font-weight: bolder;
    display: inline-block;
    background: #79C4C7;
    border-radius: 50%;
    color: white;
    font-size: 20px;
    cursor: pointer;
  }

  .submit-btn {
    display: block;
    border: none;
    width: 80px;
    height: 24px;
    line-height: 16px;
    color: #fff;
    background: #8CBB77;
    border-radius: 12px;
    text-align: center;
    margin: 50px auto 0;
    font-size: 12px;
    cursor: pointer;
    outline: none;
  }
}

.content > span, .remark > span {
  display: inline-block;
  width: 50px;
  text-align: justify;
  text-align-last: justify;
}

</style>



// WEBPACK FOOTER //
// src/pages/genjin/insert.vue